var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipContent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 480,
    height: 170,
    "aria-labelledby": titleId,
    viewBox: "0 0 480 170",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8,
    rx: 3,
    ry: 3,
    width: 144,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 33,
    rx: 3,
    ry: 3,
    width: 240,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 15,
    rx: 3,
    ry: 3,
    width: 120,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 16,
    rx: 0,
    ry: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 34,
    rx: 0,
    ry: 0,
    width: 143,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63,
    rx: 5,
    ry: 5,
    width: 170,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 63,
    rx: 5,
    ry: 5,
    width: 99,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 63,
    rx: 5,
    ry: 5,
    width: 99,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 63,
    rx: 5,
    ry: 5,
    width: 88,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 85,
    rx: 5,
    ry: 5,
    width: 138,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 85,
    rx: 5,
    ry: 5,
    width: 110,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 85,
    rx: 5,
    ry: 5,
    width: 71,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 85,
    rx: 5,
    ry: 5,
    width: 46,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 85,
    rx: 5,
    ry: 5,
    width: 45,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105,
    rx: 5,
    ry: 5,
    width: 80,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 105,
    rx: 5,
    ry: 5,
    width: 99,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 105,
    rx: 5,
    ry: 5,
    width: 123,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 105,
    rx: 5,
    ry: 5,
    width: 64,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 126,
    rx: 5,
    ry: 5,
    width: 170,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 126,
    rx: 5,
    ry: 5,
    width: 125,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 126,
    rx: 5,
    ry: 5,
    width: 69,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 126,
    rx: 5,
    ry: 5,
    width: 86,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148,
    rx: 5,
    ry: 5,
    width: 138,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 148,
    rx: 5,
    ry: 5,
    width: 110,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 148,
    rx: 5,
    ry: 5,
    width: 75,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423,
    y: 297,
    rx: 5,
    ry: 5,
    width: 49,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 148,
    rx: 5,
    ry: 5,
    width: 138,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 105,
    rx: 5,
    ry: 5,
    width: 80,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 85,
    rx: 5,
    ry: 5,
    width: 42,
    height: 15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#96abba",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipContent);
export default __webpack_public_path__ + "static/media/tooltip_content.9e35db97ad2e29609ac211f41bc6dbdc.svg";
export { ForwardRef as ReactComponent };